import React, { useState } from 'react';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { downloadExportExcel } from '../utils/formatters';

// Excel export of the active classification with the current filters, fetched
// as an authenticated blob (the Bearer token travels via reconClient — a
// plain link through Kong could not carry it).
const ExportExcelButton = ({ classification, filters, disabled }) => {
  const { reconciliation: r } = useTranslatedMessages();
  const [downloading, setDownloading] = useState(false);

  const handleExport = async () => {
    setDownloading(true);
    try {
      await downloadExportExcel({ classification, ...filters }, classification);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<FileDownloadOutlinedIcon />}
      onClick={handleExport}
      disabled={disabled || downloading || !classification}
      sx={{ textTransform: 'none', height: 34, flexShrink: 0, fontSize: 13 }}
    >
      {r.export_excel ?? 'Export Excel'}
    </Button>
  );
};

export default ExportExcelButton;
